import clsx from "clsx";
import type { ReactElement } from "react";
import styles from "./styles.module.css";

interface Props {
  className?: string;
}

export function Loader(props: Props): ReactElement {
  const { className } = props;

  return <div className={clsx(styles.Loader, className)} />;
}
